import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { useTheme } from '../context/ThemeContext';
import './Sidebar.css';

interface SidebarProps {
  isOpen: boolean;
  onToggle: () => void;
}

export default function Sidebar({ isOpen, onToggle }: SidebarProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const { colors, theme, setTheme } = useTheme();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
      alert('Failed to log out');
    }
  };

  return (
    <>
      {/* Sidebar */}
      <div 
        className={`sidebar ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}
        style={{ 
          background: colors.card
        }}
      >
        <div className="sidebar-header">
          <img
            src="/pix-logo.png"
            alt="Pixano"
            style={{ height: '44px', width: '44px', objectFit: 'contain', flexShrink: 0 }}
          />
          {isOpen && (
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.15 }}>
              <span style={{ fontWeight: 700, fontSize: 15, letterSpacing: 0.5 }}>PIXANO CLIENT</span>
              <span style={{ fontSize: 12, color: '#6b7280' }}>Data Console</span>
            </div>
          )}
        </div>

        <nav className="sidebar-nav">
          <Link
            to="/dashboard"
            className={`sidebar-link ${isActive('/dashboard') ? 'active' : ''}`}
            style={{
              background: isActive('/dashboard') ? colors.primary + '20' : 'transparent',
              color: isActive('/dashboard') ? colors.primary : colors.text,
            }}
          >
            <span className="sidebar-link-icon">📊</span>
            {isOpen && <span>Dashboard</span>}
          </Link>

          <Link
            to="/marketplace"
            className={`sidebar-link ${isActive('/marketplace') ? 'active' : ''}`}
            style={{
              background: isActive('/marketplace') ? colors.primary + '20' : 'transparent',
              color: isActive('/marketplace') ? colors.primary : colors.text,
            }}
          >
            <span className="sidebar-link-icon">🛒</span>
            {isOpen && <span>Marketplace</span>}
          </Link>

          <Link
            to="/library"
            className={`sidebar-link ${isActive('/library') ? 'active' : ''}`}
            style={{
              background: isActive('/library') ? colors.primary + '20' : 'transparent',
              color: isActive('/library') ? colors.primary : colors.text,
            }}
          >
            <span className="sidebar-link-icon">📁</span>
            {isOpen && <span>My Library</span>}
          </Link>

          <Link
            to="/exports-history"
            className={`sidebar-link ${isActive('/exports-history') ? 'active' : ''}`}
            style={{
              background: isActive('/exports-history') ? colors.primary + '20' : 'transparent',
              color: isActive('/exports-history') ? colors.primary : colors.text,
            }}
          >
            <span className="sidebar-link-icon">📜</span>
            {isOpen && <span>Exports History</span>}
          </Link>

          <Link
            to="/billing"
            className={`sidebar-link ${isActive('/billing') ? 'active' : ''}`}
            style={{
              background: isActive('/billing') ? colors.primary + '20' : 'transparent',
              color: isActive('/billing') ? colors.primary : colors.text,
            }}
          >
            <span className="sidebar-link-icon">💳</span>
            {isOpen && <span>Billing</span>}
          </Link>
        </nav>

        <div className="sidebar-footer">
          <button
            onClick={handleLogout}
            className="sidebar-logout-btn"
            style={{
              background: 'transparent',
              color: colors.secondary,
              borderColor: colors.border
            }}
            title="Log Out"
          >
            {isOpen && <span>Log Out</span>}
          </button>
          <button
            onClick={() => setTheme(theme.mode === 'dark' ? 'light' : 'dark')}
            className="sidebar-theme-toggle"
            style={{
              background: colors.toggleInactive,
              color: colors.text,
              borderColor: colors.border
            }}
            title={theme.mode === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
          >
            {theme.mode === 'dark' ? '☀️' : '🌙'}
          </button>
        </div>
      </div>

      {/* Toggle Button */}
      <button
        onClick={onToggle}
        className="sidebar-toggle-btn"
        style={{
          background: colors.card,
          borderColor: colors.border,
          color: colors.text
        }}
      >
        {isOpen ? '◀' : '▶'}
      </button>
    </>
  );
}

